import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { StateService } from "@uirouter/angularjs";
import { IScope, IRootScopeService } from "angular";
import { PlanningSessionService } from "../services/planningSessionService";

interface INudgePeopleService {
  targetName: string;
  planningSessionId: string;
}

export interface INudgePeopleCtrlScope extends IScope {
  indicators: {
    sending: boolean;
  };
  params: INudgePeopleService;
  message: string;
  postMessage();
}

export class NudgePeopleCtrl {
  public static $inject = ["$rootScope", "$scope", "$state", "$stateParams", "PlanningSessionService", "UIErrorHandlingService"];

  constructor(
    private $rootScope: IRootScopeService,
    private $scope: INudgePeopleCtrlScope,
    private $state: StateService,
    private $stateParams: INudgePeopleService,
    private planningSessionService: PlanningSessionService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.init();
  }

  private audience: string;

  private strings = {
    sending: "sending",
    pendingReviewsDashed: "pending-reviews",
    draftOwnersDashed: "draft-owners",
    reviewers: "reviewers",
    owners: "owners",
  };

  private init = (): void => {
    this.$scope.indicators = {
      sending: false,
    };

    this.$scope.params = { ...this.$stateParams };

    this.$scope.postMessage = this.postMessage;

    this.audience = this.configureAudience(this.$stateParams.targetName);
  };

  private configureAudience = (targetName: string): string => {
    switch (targetName) {
      case this.strings.pendingReviewsDashed:
        return this.strings.reviewers;

      case this.strings.draftOwnersDashed:
        return this.strings.owners;

      default:
        break;
    }
  };

  private postMessage = (): void => {
    this.$scope.indicators.sending = true;

    this.planningSessionService.nudgePeople(this.$stateParams.planningSessionId, this.audience, this.$scope.message).then(
      () => {
        this.$scope.indicators.sending = false;

        this.$rootScope.$broadcast("goalsChanged");

        this.$state.go("^.assignees", { assigneesStatName: this.$stateParams.targetName });
      },
      (err) => this.handleIndicatorError(err, this.strings.sending, true)
    );
  };

  private handleIndicatorError = <E>(err: E, indicator: string, inline = false): void => {
    this.uiErrorHandlingService.handleIndicator(err, { indicator, inline });
  };
}
